"use client";

import { Carousel } from "../Carousel";
import GalleryShortsVideoCard from "../GalleryShortsVideoCard";
import styles from "./GalleryShortsVideo.module.scss";
import VideoModal from "../VideoModal/VideoModal";
import { DeviceType, VideoMetadata, VideoSource } from "@interfaces/video";
import { useState } from "react";
import { createVideoSource } from "@utils/videoUtils";
import { ExclusiveMediaItem } from "@interfaces/vehicle-features.types";

export default function GalleryShortsVideo({
  videoCards,
  mmName,
  isLoggedIn,
  brandName,
  modelName,
}: {
  videoCards: ExclusiveMediaItem[];
  mmName: string;
  isLoggedIn: boolean;
  brandName?: string;
  modelName?: string;
}) {
  // Handle video card click
  const handleVideoClick = (
    url: string,
    metadata: VideoMetadata,
    index?: number
  ) => {
    if (typeof window !== 'undefined' && window.innerWidth <= 768) {
      setDeviceType(DeviceType.MOBILE);
    } else {
      setDeviceType(DeviceType.DESKTOP);
    }
    setSelectedVideo(createVideoSource(url));
    setSelectedMetadata(metadata);
    setIsModalOpen(true);
  };
  // Handle modal close
  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedVideo(null);
    setSelectedMetadata(null);
  };
  const [selectedMetadata, setSelectedMetadata] =
    useState<VideoMetadata | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deviceType, setDeviceType] = useState<DeviceType>(DeviceType.DESKTOP);
  const [selectedVideo, setSelectedVideo] = useState<VideoSource | null>(null);
  return (
    <section className={styles.section}>
      <Carousel heading={`${mmName} short videos`} >
        {videoCards.map((video: any, index: number) => (
          <GalleryShortsVideoCard
            key={video.fileName}
            brandName={brandName}
            modelName={modelName}
            video={{
              uri: video.url,
              thumbnail: video.metadata.thumbnail,
              title: video.metadata.title,
              locked: video.locked,
            }}
            metadata={{
              title: video.metadata.title,
              thumbnail: video.metadata.thumbnail,
              tag: (video.metadata.isExclusive || video.metadata.isLocked) ? "Exclusive" : "Acko Drive",
            }}
            onClick={() => handleVideoClick(video.url, video.metadata, index)}
            isLoggedIn={isLoggedIn}
          />
        ))}
      </Carousel>
      <VideoModal
        video={selectedVideo}
        metadata={selectedMetadata}
        isOpen={isModalOpen}
        onClose={handleModalClose}
        deviceType={deviceType}
        config={{
          autoplay: true,
          muted: false,
          showTitle: true,
          showProgress: true,
          showVolume: true,
          showClose: true,
        }}
        events={{
          // onPlay: () => console.log("Video started playing"),
          // onPause: () => console.log("Video paused"),
          // onEnded: () => console.log("Video ended"),
          onError: (error) => console.error("Video error:", error),
        }}
      />
    </section>
  );
}
